/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Microsoft_Tenant_Cleared_DescInputs */



/**
* | output |
* | --- |
* | "The Microsoft Entra tenant restriction was removed, so Microsoft accounts from any tenant are accepted again." |
*
* @param {Audit_Details_Microsoft_Tenant_Cleared_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_microsoft_tenant_cleared_desc = /** @type {((inputs?: Audit_Details_Microsoft_Tenant_Cleared_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Microsoft_Tenant_Cleared_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Beschränkung auf einen Microsoft-Entra-Mandanten wurde aufgehoben. Microsoft-Konten aus jedem Mandanten werden wieder akzeptiert.")
	return /** @type {LocalizedString} */ ("The Microsoft Entra tenant restriction was removed, so Microsoft accounts from any tenant are accepted again.")
});